class SimpleWorkbookVM {
    id: number;
    name: string;
    editMode: WorkbookEditModeEnum;
    ownerUserName: string;
    ownerEmail: string;
    mappingId: number;
    hasEmails: boolean;

    constructor(data: any) {
        this.id = data.id;
        this.name = data.name;
        this.editMode = data.editMode;
        this.ownerUserName = data.ownerUserName;
        this.ownerEmail = data.ownerEmail;
        this.mappingId = data.mappingId;
        this.hasEmails = data.hasEmails;
    }
}